import * as S from './styles';

export function ExclusiveProduct({ product }) {
  return (
    <S.Container className="exclusive-sale-in-physical-store">
      <strong>Venda Exclusiva nas Lojas ULTRAFARMA:</strong>

      <ul>
        {product.lojasDisponiveis.map((item, index) => (
          <li key={index}>
            {item.dadosCd}: {item.quantidade}{' '}
            {item.quantidade > 1 ? 'unidades' : 'unidade'}
          </li>
        ))}
      </ul>

      <span>Metrô Saúde Ultrafarma - São Paulo</span>

      <strong>Obrigatório a apresentação de receita médica.</strong>
    </S.Container>
  );
}
